// extracted by mini-css-extract-plugin
module.exports = {"fileStagingArea":"widget-demo--fileStagingArea--3Fudn","files":"widget-demo--files--2Vjst","chipContainer":"widget-demo--chipContainer--i2E6U"};